import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface BetaFeedback {
  name: string;
  email: string;
  rating: number;
  category: 'bug' | 'feature' | 'general' | 'ui' | 'performance';
  comments: string;
  image_url?: string;
  user_agent?: string;
  source?: string;
}

export async function uploadFeedbackImage(file: File): Promise<string> {
  const fileExt = file.name.split('.').pop();
  const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;

  const { error } = await supabase.storage
    .from('feedback-images')
    .upload(fileName, file);

  if (error) {
    throw error;
  }

  const { data: urlData } = supabase.storage
    .from('feedback-images')
    .getPublicUrl(fileName);

  return urlData.publicUrl;
}

export async function submitBetaFeedback(feedback: BetaFeedback) {
  const { data, error } = await supabase
    .from('beta_feedback')
    .insert({
      ...feedback,
      user_agent: navigator.userAgent,
      source: 'web',
    });

  if (error) {
    throw error;
  }

  return data;
}

export interface BetaTester {
  name: string;
  email: string;
  platform: 'ios' | 'android';
}

export async function submitBetaTester(tester: BetaTester) {
  const { data, error } = await supabase
    .from('beta_testers')
    .insert(tester);

  if (error) {
    throw error;
  }

  return data;
}
